import { render, staticRenderFns } from "./ExtractShobunrui.vue?vue&type=template&id=a90f4422&"
import script from "./ExtractShobunrui.vue?vue&type=script&lang=ts&"
export * from "./ExtractShobunrui.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports